/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TextFieldModule } from '@angular/cdk/text-field';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
/**
 * Modal imports.
 */
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgbDropDownModule } from './../ngb-drop-down/ngb-drop-down.module';
import { DirectivesModule } from './../../directives/directives.module';
import { UserProfilePicModule } from './../user-pofile-pic/user-profile-pic.module';
import { ProductLikeModule } from './../product-like/product-like.module';
import { InfoModalModule } from '../info-modal/info-modal.module';
import { ConfirmModalModule } from '../confirm-modal/confirm-modal.module';
import { ContentCardModule } from '../content-card/content-card.module';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AnalyticsEventModule } from '../../analytics-event/analytics-event.module';
import { WalkthroughModule } from './../../walkthrough/walkthrough.module';
/**
 * Component imports.
 */
import { CommentCardComponent } from './comment-card/comment-card.component';
import { ProductCommentComponent } from './product-comment.component';
import { ReplyCommentCardComponent } from './reply-comment-card/reply-comment-card.component';
import { ReplySuggestionListForTagUsersComponent } from './reply-suggestion-list-for-tag-users/reply-suggestion-list-for-tag-users.component';

/**
 * Pipes Import
 */
import { PipesModule } from '../../pipes/pipes.module';



/**
 * Module imports
 */
import { CarouselModule } from 'ngx-owl-carousel-o';


@NgModule({
  declarations: [
    ProductCommentComponent,
    CommentCardComponent,
    ReplyCommentCardComponent,
    ReplySuggestionListForTagUsersComponent
  ],
  imports: [
    CommonModule,

    InfoModalModule,
    ProductLikeModule,
    UserProfilePicModule,
    DirectivesModule,
    ConfirmModalModule,
    NgbDropDownModule,
    ContentCardModule,
    FormsModule,
    TextFieldModule,
    ModalModule,
    NgbModalModule,
    NgbModule,
    AnalyticsEventModule,
    WalkthroughModule,
    PerfectScrollbarModule,
    InfiniteScrollModule,
    CarouselModule,
    PipesModule
  ],
  exports: [
    ProductCommentComponent,
    CommentCardComponent,
    ReplyCommentCardComponent,
    ReplySuggestionListForTagUsersComponent,
    WalkthroughModule,
    PerfectScrollbarModule,
    InfiniteScrollModule
  ]
})
export class ProductCommentModule { }
